export default __webpack_public_path__ + "static/media/Volunteer.7cca7bfc.svg";